
import { defineComponent } from '@vue/composition-api';
import {
  multiOmicsForm, templateHasData,
} from '../store';
import { HARMONIZER_TEMPLATES } from '@/views/SubmissionPortal/types';

export default defineComponent({
  props: {
    legend: {
      type: String,
      default: 'Data Types',
    },
    showDataCompatibilityQuestions: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, { emit }) {
    const dataCaveat = 'You may proceed with your submission for sample metadata capture. However, there will not be place to provide information about your existing sequencing data as the methods are not supported by NMDC Workflows';

    const handleMetagenomeChange = (value: string[]) => {
      if (!value.includes('mg')) {
        multiOmicsForm.mgCompatible = undefined;
        multiOmicsForm.mgInterleaved = undefined;
      }
      emit('revalidate');
    };

    const handleMgCompatibleChange = (value: boolean) => {
      if (!value) {
        multiOmicsForm.mgInterleaved = undefined;
      }
      emit('revalidate');
    };

    const handleMetatranscriptomeChange = (value: string[]) => {
      if (!value.includes('mt')) {
        multiOmicsForm.mtCompatible = undefined;
        multiOmicsForm.mtInterleaved = undefined;
      }
      emit('revalidate');
    };

    const handleMtCompatibleChange = (value: boolean) => {
      if (!value) {
        multiOmicsForm.mtInterleaved = undefined;
      }
      emit('revalidate');
    };

    return {
      dataCaveat,
      multiOmicsForm,
      HARMONIZER_TEMPLATES,
      templateHasData,
      handleMetagenomeChange,
      handleMgCompatibleChange,
      handleMetatranscriptomeChange,
      handleMtCompatibleChange,
    };
  },

});

